var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fas abk-caret",class:_vm.open ? 'fa-caret-up' : 'fa-caret-down'})}
var staticRenderFns = []

export { render, staticRenderFns }